import { TOOLTIP_CONTAINER_ID } from './constants';

export const getTooltipContainer = (): HTMLElement => {
  return document.getElementById(TOOLTIP_CONTAINER_ID) || document.getElementsByTagName('body')[0];
};
